import { useState, FormEvent } from 'react';

export default function ContactForm() {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    // Honeypot anti-spam : si rempli, on simule un succès sans rien envoyer.
    const honeypot = formData.get('phone_alt');
    if (honeypot && String(honeypot).trim() !== '') {
      setStatus('success');
      form.reset();
      return;
    }

    // On ne garde que les champs utiles pour Web3Forms.
    const payload = new URLSearchParams();
    formData.forEach((value, key) => {
      if (key !== 'phone_alt') {
        payload.append(key, String(value));
      }
    });
    payload.append('from_name', 'Proximité Confiance Finistère');
    payload.append('subject', 'Nouvelle demande de contact');

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Accept: 'application/json',
        },
        body: payload.toString(),
      });

      const responseText = await response.text();
      let parsed;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      if (response.ok && parsed?.success === true) {
        setStatus('success');
        form.reset();
      } else {
        setStatus('error');
        setErrorMsg(
          parsed?.message || 'Une erreur est survenue. Veuillez réessayer.',
        );
      }
    } catch {
      setStatus('error');
      setErrorMsg('Erreur de connexion. Veuillez réessayer.');
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <input type="hidden" name="access_key" value="d4d45d9d-ba6c-4e92-b3ae-3b21b3014036" />

      <div>
        <label htmlFor="name" className="block font-body text-sm text-foreground-700 mb-2">Nom *</label>
        <input
          type="text"
          id="name"
          name="name"
          required
          className="w-full bg-background-100 border border-background-300 rounded-md px-4 py-3 font-body text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400"
        />
      </div>
      <div>
        <label htmlFor="email" className="block font-body text-sm text-foreground-700 mb-2">Email *</label>
        <input
          type="email"
          id="email"
          name="email"
          required
          className="w-full bg-background-100 border border-background-300 rounded-md px-4 py-3 font-body text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400"
        />
      </div>
      <div>
        <label htmlFor="message" className="block font-body text-sm text-foreground-700 mb-2">Message *</label>
        <textarea
          id="message"
          name="message"
          required
          maxLength={500}
          rows={5}
          className="w-full bg-background-100 border border-background-300 rounded-md px-4 py-3 font-body text-sm text-foreground-950 focus:outline-none focus:ring-2 focus:ring-primary-400 resize-y"
        />
        <p className="text-xs text-foreground-500 mt-1">500 caractères maximum</p>
      </div>
      <input
        type="text"
        name="phone_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
      />
      <button
        type="submit"
        className="bg-primary-500 text-background-50 dark:text-foreground-950 px-8 py-4 rounded-full font-body text-sm tracking-wide hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
      >
        Envoyer
      </button>
      <p className="font-body text-xs text-foreground-500 mt-1">* champs obligatoires</p>

      {status === 'success' && (
        <p className="font-body text-sm text-green-700">Votre message a bien été envoyé. Merci !</p>
      )}
      {status === 'error' && (
        <p className="font-body text-sm text-red-600">{errorMsg}</p>
      )}
    </form>
  );
}